import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=cb625ba8"
import script from "./Badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badge.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Badge.vue?vue&type=style&index=0&id=cb625ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports